export default {
  biFormsBySiteAndDate: 'BI_FORMS_BY_SITE_AND_DATE',
  biFormsByDate: 'BI_FORMS_BY_DATE',
  biFormsByCategory: 'BI_FORMS_BY_CATEGORY',
  setLoadingState: 'BI_FORMS_SET_LOADING_STATE',
};
